/* Mobile sticky Add to Cart bar. Never duplicates cart logic: the bar's button
   just proxies a click to the real (Dawn) submit button, so variant selection,
   quantity, cart-drawer behaviour etc. all stay exactly as Dawn already built them.
   Visibility is driven by whether the real buy-buttons block is on screen. */
(function () {
  'use strict';

  document.querySelectorAll('.ticho-sticky-atc').forEach(function (bar) {
    var sectionId = bar.dataset.sectionId;
    var anchor = document.getElementById('ProductInfo-' + sectionId + '-buy-buttons-anchor');
    if (!anchor) return;

    // Dawn's product-info.js does destination.innerHTML = source.innerHTML on
    // variant change, which destroys and recreates the button/price nodes — so
    // these must be looked up fresh on every use, never cached across a variant
    // change, or the sticky bar ends up proxying a click to a detached button.
    function getRealButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }
    function getPriceSource() {
      return document.getElementById('price-' + sectionId);
    }

    var barButton = bar.querySelector('.ticho-sticky-atc__button');
    var barButtonLabel = bar.querySelector('.ticho-sticky-atc__button-label');
    var barPrice = bar.querySelector('.ticho-sticky-atc__price');

    function syncFromRealButton() {
      var realButton = getRealButton();
      var priceSource = getPriceSource();
      if (!realButton) return;
      var label = realButton.querySelector('span');
      if (barButtonLabel && label) barButtonLabel.textContent = label.textContent.trim();
      barButton.disabled = realButton.disabled;
      if (barPrice && priceSource) {
        var current = getCurrentPrice(priceSource);
        if (current) barPrice.textContent = current;
      }
    }

    // Only the selected variant's current price goes into the bar. The price
    // block also carries the START10 line, Omnibus and tax notes, which must
    // not be duplicated here (copying innerHTML used to bring them along).
    function getCurrentPrice(priceSource) {
      var price = priceSource.querySelector('.price');
      if (!price) return '';
      var item = price.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--sale')
        : price.querySelector('.price__regular .price-item--regular');
      return item ? item.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    barButton.addEventListener('click', function () {
      var realButton = getRealButton();
      if (realButton) realButton.click();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px 0px 0px' }
      );
      observer.observe(anchor);
    }

    syncFromRealButton();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(syncFromRealButton, 0);
      });
    }
  });
})();
